import type { AnyQuestion, Country } from "../../types";
import QuestionResolver from "./question-resolver";
import { QuestionnaireCondition } from "./question-types/questionnaire-condition";
import { formatFieldName } from "./utils";

type Props = {
	question: AnyQuestion;
	allCountries: Array<Country>;
};

export const Question = ({ question, allCountries }: Props) => (
	<>
		<QuestionResolver question={question} allCountries={allCountries} />
		{question.answerChoices.map((answerChoice) =>
			// render questions recursively until subquestions are empty: //
			answerChoice.subQuestions.map((subQuestion) => (
				<QuestionnaireCondition
					when={formatFieldName(question.questionId)}
					is={answerChoice}
					key={subQuestion.questionId}
					subQuestion={subQuestion}
				>
					<Question question={subQuestion} allCountries={allCountries} />
				</QuestionnaireCondition>
			)),
		)}
	</>
);
